<template>
    <div class="sm:px-6 mb-8">
        <div
            class="bg-white shadow overflow-hidden rounded-lg border border-gray-200 divide-y divide-gray-200 w-full mx-auto max-w-xl md:max-w-none"
        >
            <div>
                <div class="flex justify-center py-36 px-6" v-if="loading">
                    <RefreshIcon
                        class="h-24 w-24 animate-spin text-gray-400"
                        aria-hidden="true"
                    />
                </div>

                <div v-if="!loading" class="table-responsive">
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead class="bg-gray-50">
                            <tr>
                                <th
                                    scope="col"
                                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    Date
                                </th>

                                <th
                                    scope="col"
                                    class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    Total
                                </th>

                                <th
                                    v-if="canSeeRevenue"
                                    scope="col"
                                    class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    Revenue
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                            <tr
                                v-for="(
                                    salesTotal, salesTotalId
                                ) in salesTotals"
                                :key="salesTotal.date"
                                :class="
                                    salesTotalId % 2 === 0
                                        ? 'bg-white'
                                        : 'bg-gray-50'
                                "
                            >
                                <td
                                    class="px-6 py-4 text-left whitespace-nowrap text-sm font-medium text-gray-900"
                                >
                                    {{ salesTotal.date }}
                                </td>

                                <td
                                    class="px-6 py-4 text-center whitespace-nowrap text-sm text-gray-500"
                                >
                                    {{ salesTotal.count }}
                                </td>

                                <td
                                    v-if="canSeeRevenue"
                                    class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500"
                                >
                                    ${{ salesTotal.revenue }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { RefreshIcon } from "@heroicons/vue/outline";
import { getSalesTotals } from "../../api/dashboard";

defineProps<{
    canSeeRevenue?: string;
}>();

const salesTotals = ref<any[]>([]);
const loading = computed(() => _.isEmpty(salesTotals.value));

getSalesTotals().then((data) => {
    salesTotals.value = data.salesTotals;
});
</script>
